/* eslint-disable */
import './index.global.scss';
import React from 'react';
import ReactDOM from 'react-dom';
import queryString from 'query-string';
import { BrowserRouter as Router } from 'react-router-dom';
//import { Provider } from 'react-redux';
import GlobalProvider from './context/GlobalProvider';
import { version, name } from '#/package.json';
import { Container, connect } from '@cerebral/react';
import { state } from 'cerebral/tags';
import * as serviceWorker from '~/utils/serviceWorker';
import configData from './config/data';
import Controller from './components/FormSchedule/Controller';
//import store from './store';
import App from './App';

const putDeviceTypeOnBody = (mobile) => {
	document.body.classList.remove(mobile ? 'is-desktop' : 'is-mobile');
	document.body.classList.add(mobile ? 'is-mobile' : 'is-desktop');
};

const putGlobalVariables = () => {
	const locationSearch = queryString.parse(window.location.search);
	return configData.clusters.findCluster(locationSearch.seu);
};

const Device = connect(
	{ media: state`useragent.media` },
	({ media, ...props }) => {
		putDeviceTypeOnBody(media.mobile);
		return (
			<Router>
				<App
					{...props}
					name={name}
					cluster={putGlobalVariables()}
					version={version}
					mobile={media.mobile}
					desktop={!media.mobile}
				/>
			</Router>
		);
	},
);

const render = () => {
	ReactDOM.render(
		<GlobalProvider>
			<Container controller={Controller}>
				<Device />
			</Container>
		</GlobalProvider>,
		document.querySelector(`[data-ui-stage="${name}"]`),
	);
};

serviceWorker.unregister();
render();

if (module.hot) {
	module.hot.accept(() => {
		console.log('*** Accepting the updated render module! ***');
		render();
	});
}
